// extracted by mini-css-extract-plugin
export default {"tabsContent":"src-components-TabsContent--tabsContent","tabsContent_active":"src-components-TabsContent--tabsContent_active"};